<app-admin-custom-control [label]="label" [centerLabel]="centerLabel" [labelCols]="labelCols"
    [dividerKind]="dividerKind" [disabled]="disabled">
    <div class="input-group">
        <textarea [rows]="rows" [id]="'input'+uniqueId" [appFocus]="focusInput" class="form-control"
            [disabled]="disabled" [(ngModel)]="model" (ngModelChange)="modelChange.emit(model)"
            (click)="clickModel($event)" [placeholder]="placeholder?placeholder:''" autocomplete="off"></textarea>
        <ng-content></ng-content>
    </div>
</app-admin-custom-control>